
import { defineComponent } from "vue";
import SearchComponent from "@/components/search-form/SearchFormComponent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    SearchComponent,
  },
});
